module.exports = __webpack_public_path__ + "4be5b3eacabce43dddcca2062f91f207.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/john-feminella.jpg
// module id = 514
// module chunks = 0